import React, { forwardRef, Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { css } from '@styled-system/css'

import { useModal_deprecated } from 'hooks'
import { Box, breakpoints, Header, ResponsiveImage, P } from 'ui/acro'

const CardContainer = styled('a')(
  css({
    maxWidth: ['260px', '410px'],
    display: 'flex',
    flexDirection: 'column',
    '&:not(:last-child)': {
      mr: [null, '16px', null, '45px']
    }
  })
)

const GradientOverlay = styled(Box)({
  position: 'absolute',
  top: '0',
  height: '100%',
  width: '100%'
})

const Title = styled(P)({
  fontFamily: `${(props) => props.theme.fonts.Proxima}`,
  textTransform: 'uppercase',
  fontWeight: '600',
  textAlign: 'center',
  fontSize: ['16px', '22px'],
  width: '80%',
  margin: '0 auto',
  padding: '0 0 10px 0'
})

const StoryCard = forwardRef(({ images, alt, body, title, link }, ref) => {
  const imagesArray = [
    {
      src: images.desktop,
      breakpoint: breakpoints[0]
    }
  ]

  return (
    <Fragment>
      <CardContainer
        ref={ref}
        className='swiper-slide'
        position='relative'
        maxWidth={['260px', '450px']}
        cursor='pointer'
        id={title}
        aria-label={title}
        flex={['', null, '1']}
        href={link}
        target='_blank'
      >
        <Title>{title}</Title>
        <GradientOverlay />
        <ResponsiveImage
          src={images.mobile}
          alt={alt}
          imagesArray={imagesArray}
          width='100%'
          objectFit='cover'
        />
        <Box
          position='absolute'
          bottom='0'
          px={['16px', '34px']}
          pb={['28px', '38px']}
        >
          <Header variant='semibold' color='white' mt='10px' width='70%'>
            {body}
          </Header>
        </Box>
      </CardContainer>
    </Fragment>
  )
})

StoryCard.propTypes = {
  videos: PropTypes.array.isRequired,
  images: PropTypes.object.isRequired,
  alt: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
}

export default StoryCard
